import { TextMaskModule } from 'angular2-text-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ProfileRoutingModule } from './profile-routing.module';
import { AccountSettingComponent, ResetPassword } from './account-setting/account-setting.component';
import { ChangeMobileNumber } from './account-setting/account-setting.component';
import { ProfileService } from './profile.service';
import { ContactSupport } from './account-setting/account-setting.component';
import { ChangeMailingAddress } from './account-setting/account-setting.component';
import { PipeModule } from '../shared/pipe/pipe.module';
import { FirstLetterUpperCase } from '../shared/pipe/firstletteruppercase.pipe';
import { UpdateEmailComponent } from './update-email/update-email.component';
import { UpdateEmailAddress } from './update-email/update-email.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatTooltipModule } from '@angular/material';
import { NotificationPreferenceComponent } from './notification-preference/notification-preference.component';
import { ContactInfoComponent, UpdateContact } from './contact-info/contact-info.component';
import { ContactVerifyComponent } from './contact-verify/contact-verify.component';
import {AuthModule} from '../auth/auth.module';

@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    PipeModule.forRoot(),
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TextMaskModule,
    AuthModule
  ],
  providers: [ProfileService, FirstLetterUpperCase],
  declarations: [
    AccountSettingComponent,
    ContactSupport,
    ChangeMailingAddress,
    ChangeMobileNumber,
    UpdateEmailComponent,
    UpdateEmailAddress,
    ResetPassword,
    NotificationPreferenceComponent,
    ContactInfoComponent,
    UpdateContact,
    ContactVerifyComponent
  ],
  bootstrap: [ContactSupport, ChangeMailingAddress, ChangeMobileNumber, UpdateEmailAddress, ResetPassword, UpdateContact],
})
export class ProfileModule { }



// WEBPACK FOOTER //
// ./src/app/profile/profile.module.ts